import { useCallback } from "react";
import gql from "graphql-tag";
import { useMutation } from "@apollo/react-hooks";
import { COMMENTS_QUERY } from "../useComments";

const DELETE_COMMENT = gql`
  mutation deleteComment($id: ID!) {
    deleteComment(id: $id)
  }
`;

export default (workId, commentId) => {
  const [deleteComment, { loading, error }] = useMutation(DELETE_COMMENT, {
    awaitRefetchQueries: true,
    refetchQueries: [
      {
        query: COMMENTS_QUERY,
        variables: { workId },
      },
    ],
  });

  const memorizedDeleteComment = useCallback(
    ({ callback = () => {} }) =>
      () =>
        deleteComment({
          variables: {
            id: commentId,
          },
        }).finally(() => callback()),
    [commentId, deleteComment]
  );

  return {
    deleteComment: memorizedDeleteComment,
    deleteCommentLoading: loading,
    deleteCommentError: error,
  };
};
